module.exports = __webpack_public_path__ + "static/Disinfection-logo-15e40013b04fcea026f2ea791bf63adb.png";